import { Components, Theme } from "@mui/material";
import { PrimaryColors } from "../../../style/Colors";

export const MuiTablePagination: Components<Theme>["MuiTablePagination"] = {
  styleOverrides: {
    root: {
      backgroundColor: PrimaryColors.base,
      color: "inherit",
    },
  },
};
